import React from 'react';
import { PrimaryButton } from '@fluentui/react';
import { Color } from '../../const/Const';

const ButtonBack = (props) => {

    return (
        <div style={{ color: Color.black, fontWeight: 400, fontSize: 14, height: 32, display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={props.onClick}>
            {props.text}
        </div>
    );
}

export default ButtonBack;